// extracted by mini-css-extract-plugin
export default {"main":"Password_main__Q+cil","form-field":"Password_form-field__wnNGk"};